export const selectCategoriesSelected = (state) => state.SelectedCategoriesData.selectedCategories;

export const selectRenewMode = (state) => state.SelectedCategoriesData.renewCategories;
